import { AuthenticationResponsesValidateTfaToken } from '@genial/services/dist/models';
import { Utils } from '@genial/utils';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';

import { useFixedFeeTermAcceptanceLinkActions } from '../../../store/fixedFeeTermAcceptanceLink/action';
import { fixedFeePublicTermIdState } from '../../../store/fixedFeeTermAcceptanceLink/atom';

export const useAuthenticationTerm = () => {
  const { postTfaCode } = useFixedFeeTermAcceptanceLinkActions();
  const termId = useRecoilValue(fixedFeePublicTermIdState);

  const [loadingToken, setLoadingToken] = useState(false);
  const [errorValidateToken, setErrorValidateToken] = useState(false);
  const [isValidatedToken, setIsValidatedToken] = useState(false);
  const [isExpiredToken, setIsExpiredToken] = useState(false);

  const validateJwtToken = (token: AuthenticationResponsesValidateTfaToken) => {
    const jwtToken = token.jwtToken || '';
    const decoded = Utils.Jwt.Validate(jwtToken);
    const isExpired = decoded && Utils.Jwt.Expired(jwtToken);

    if (decoded && !isExpired) {
      setIsValidatedToken(true);
    } else {
      setIsExpiredToken(true);
    }
  };

  const handleValidateToken = async (value: string) => {
    try {
      setLoadingToken(true);
      setErrorValidateToken(false);

      const tfaToken = await postTfaCode({
        tfaCode: value,
        termId,
      });

      if (tfaToken) {
        validateJwtToken(tfaToken);
      }
    } catch (_error) {
      setErrorValidateToken(true);
    } finally {
      setLoadingToken(false);
    }
  };

  return {
    isValidatedToken,
    errorValidateToken,
    handleValidateToken,
    loadingToken,
    isExpiredToken,
  };
};
